module.exports = __webpack_public_path__ + "img/Toshihiko_Yamasaki@2x.c8df7759.png";